import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgRooms = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#F7A941"
      d="M34 7H10v24h24z"
    />
    <path
      fill="#F18700"
      d="M20 20H6v14h14z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgRooms);

export default ForwardRef;
